// @flow

/**
 * Chart Tooltip Component
 * Displays formatted series values on hover.
 * Used by ComposedGraphDisplay, LineGraphDisplay (legacy), BarGraphDisplay (legacy).
 */

import React from 'react';
import { formatValue } from './formatters';

type Props = {
  active?: boolean,
  payload?: Array<any>,
  label?: string,
  yAxes: Array<{ key: string, valueType: string, [key: string]: any }>,
};

const ChartTooltip = ({ active, payload, label, yAxes }: Props) => {
  if (!active || !payload || payload.length === 0) return null;

  return (
    <div style={{
      background: 'white',
      border: '1px solid rgba(0,0,0,0.15)',
      borderRadius: 4,
      padding: '0.5rem 0.75rem',
      fontSize: '0.8rem',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    }}>
      <div style={{ fontWeight: 600, marginBottom: '0.25rem' }}>{label}</div>
      {payload.map((entry, i) => {
        const axisDef = yAxes.find(y => y.key === entry.dataKey);
        const vType = axisDef?.valueType || 'number';
        return (
          <div key={i} style={{ color: entry.color }}>
            {entry.name}: {formatValue(entry.value, vType)}
          </div>
        );
      })}
    </div>
  );
};

export default ChartTooltip;
